import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=7dc50ff0&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=js"
export * from "./UserSelector.vue?vue&type=script&lang=js"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=7dc50ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc50ff0",
  null
  
)

export default component.exports